export default __webpack_public_path__ + "c7808c009cf06a91d80bec5e111ad5c8.jpg";